import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
    ru: {
        common: {
            submit: 'Продолжить',
            address: 'Адрес',
            telephone: 'Телефон',
            email: 'Email',
            fax: 'Факс',
            firstName: 'Имя',
            middleName: 'Отчество',
            lastName: 'Фамилия',
            viewOnMap: 'Показать на карте',
            month: 'Выберите месяц',
            day: 'Выберите день',
            time: 'Выберите время',
            confirmationTitle: 'Подтверждение Вашей записи',
            codeSMS: 'Введите SMS код',
            cancelBooking: 'Отменить запись',
            submitBooking: 'Подтвердить запись',
            userLocationTitle: 'Выберите свой город, чтобы найти ближайшие дилерские центры',
            userLocationDescription: 'Выберите Ваш город',
            changeLocation: 'Изменить местоположение',
            footerMessage: 'Данные о расходе топлива приведены в результате испытаний официального производителя в соответствии с законодательством ЕС.\nФактический расход топлива на транспортном средстве может отличаться от значения, достигнутого в таких испытаниях, и эти цифры приведены только для сравнительных целей.',
            phoneNotice: 'Мы отправим на этот номер 6-значный SMS-код для подтверждения вашего бронирования.',
            accept: 'Я принимаю',
            termsAndConditions: 'Положения и условия',
            confirmation: 'Подтверждение вашей записи',
            confirmationNotice: 'На Ваш номер <b>{phone}</b> отправлено SMS-сообщение, содержащее 6-значный код. ',
            confirmationInstruction: 'Для подтверждения бронирования введите полученный код в поле ниже.',
            confirmationCode: 'Мы отправили 6-значный код на номер',
            resendCode: 'Отправить код еще раз',
            codeResended: 'Мы повторно отправили код по вашему запросу',
            bookingNumber: 'Номер вашего бронирования: ',
            lookForward: 'Мы с нетерпением ждем Вас!',
            directionsToRetailer: 'Перейти к дилерскому центру',
            model: 'Модель',
            yourDetails: 'Ваши данные',
            fieldsMandatory: 'Все отмеченные поля являются обязательными',
            serverConnectionError: 'Не удалось получить ответ от сервера. Пожалуйста, попробуйте позже.',
            sessionExpired: 'Время вашей сессии истекло',
            startOver: 'Начать с начала',
            noCities: 'Извините, доступные города по вашему запросу не найдены',
            limitExceededTitle: 'Превышен лимит создания заявок',
            limitExceededMessage: 'К сожалению, Вы превысили лимит создания заявок. Для решения проблемы обратитесь, пожалуйста, в дилерский центр.',
            please: 'Пожалуйста',

            //title active steps
            dealersCount: 'Рядом с вами {dealersLength} {wordRu}',
            completeForm: 'Пожалуйста, укажите Ваши данные',
            dayAndTime: 'Выберите дату и время'
        },

        stepNames: {
            vehicle: 'Автомобиль',
            retailer: 'Дилерский центр',
            dateAndTime: 'Дата и время',
            contacts: 'Ваши контакты',
            name: 'Имя',
            confirmation: 'Подтверждение',
            edit: 'Изменить',

            carAndDealer: 'Автомобиль и Дилер',
            services: 'Выбор услуг',
        },

        validations: {
            required: 'Поле {name} не должно быть пустым',
            alphaNum: 'Поле {name} может содержать только цифры и буквы алфавита',
            isName: 'Поле {name} может содержать только буквы алфавита, пробелы и символы тире',
            isVin: 'Поле {name} может содержать только арабские цифры и символы латинского алфавита, за исключением букв I, O, Q',
            numeric: 'Поле {name} может содержать только цифры',
            email: 'Поле {name} должно содержать действительный адрес электронной почты',
            isPhone: 'Поле {name} должно содержать действительный номер телефона',
            phoneCode: 'Поле Телефон должно начинаться с кода одной из следуюших стран: <br> Россия(+7), Белорусь(+375), Казахстан(+7), Армения(+374), Украина(+380), Молдова(+373), Киргизия(+996), Таджикистан(+992), Узбекистан(+998), Азербайджан(+994)',
            maxLength: 'Поле {name} не должно содержать более {value} символов',
            minLength: 'Поле {name} не должно содержать меньше {value} символов',
            requiredAllFields: 'Пожалуйста, заполните все поля',
            lengthEqual: 'Поле {name} должно содержать {value} символов',
            city: 'Пожалуйста, выберите ваш город',
            services: 'Выберите хотя бы одну услугу',
            codeInvalid: '<b>Неверный код подтверждения.</b> <br> Пожалуйста, введите код, который Вы только что получили.',
            time: 'Пожалуйста, выберите дату и время',
            mobility: 'выберите вариант мобильности',
            terms: 'Для продолжения подтвердите, пожалуйста, свое согласие с положениями и условиями предоставления услуг',
            zeroValue: 'Значение поля {name} не может равняться нулю',
            tooManyIncorrectCodes: 'К сожалению, Вы превысили лимит попыток отправки кода подтверждения.  Для решения проблемы обратитесь, пожалуйста, в дилерский центр.'
        },

        maintenance: {
            title: 'Сервисное обслуживание',
            titleInDative: 'сервисному обслуживанию',

            //title active steps
            activeServices: 'Укажите какое обслуживание необходимо для Вашего автомобиля',
            confirmation: 'Подтверждение',

            lookUpCar: 'Поиск автомобиля по VIN',
            addCar: 'Добавить автомобиль',
            invalidVIN: 'Введенный VIN не найден. Пожалуйста, введите данные Вашего автомобиля вручную.',
            mileage: 'Пробег',
            modelYear: 'Модельный год',
            engineSize: 'Объем двигателя',
            fuel: 'Тип топлива',
            airType: 'Двигатель',
            selectDealer: 'Выбор дилерского центра',
            selectDateTime: 'Выбор даты и времени',
            selectMobility: 'Выберите вариант мобильности',
            deliveryChoice: 'Выберите варианты доставки',
            adviserChoice: 'Выберите мастера',
            dateTimeChoice: 'Выберите дату и время',
            dateTimeCall: 'Пожалуйста, свяжитесь с дилерским центром, если Вы хотите уточнить время или дату:',
            chooseOne: 'Выберите одного',
            anyAdviser: 'Любой мастер',
            free: 'Бесплатно',
            yourDiscount: 'Ваша скидка',
            totalPrice: 'Общая стоимость',
            additionalRequirements: 'Укажите дополнительные пожелания',
            requiredPackages: 'Обязательное обслуживание',
            requirePackages: 'Обязательное обслуживание',
            scheduledMaintenancePackages: 'Регламентное обслуживание',
            recommendPackages: 'Рекомендуемое обслуживание',
            recommendedMaintenancePackages: 'Рекомендуемое обслуживание',
            promoPackages: 'Акционные предложения',
            carePackages: 'Забота об автомобиле',
            diagnosticsPackages: 'Диагностика',
            accessoriesPackages: 'Акссессуары для Вашего авто',
            specialOffersPackages: 'Специальные предложения',
            specialOffers: 'Специальные предложения',
            reviewCampaigns: 'Отзывные компании',
            city: 'Город',
            confirmed: 'Спасибо за Вашу информацию. Ваша запись подтверждена на следующие дату и время: <b>{time}</b>',
            confirmationInfo1: 'Для уточнения любых вопросов о сервисном обслуживании, внесения изменений или отмены записи на сервис, пожалуйста, свяжитесь с выбранным дилерским центром: <b>{dealerName} {dealerPhone}</b>.',
            confirmationInfo21: 'Письмо с деталями Вашего бронирования будет отправлено на <b>{email}</b>.',
            confirmationInfo22: 'Итоговая стоимость Вашего сервисного обслуживания составит <b>{totalCost}</b>',
            confirmationInfo23: 'Для уточнения любых вопросов о сервисном обслуживании, внесения изменений или отмены записи на сервис, пожалуйста, свяжитесь с выбранным дилерским центром: <b>{dealerName} {dealerPhone}</b>.',
            noMatchingModels: 'Извините, по вашему запросу нет подходящих моделей',
            noMatchingAirTypes: 'Извините, по вашему запросу нет подходящих двигателей',
            noMatchingFuelTypes: 'Извините, по вашему запросу нет подходящих типов подачи топлива',
            noMatchingEngineSizes: 'Извините, по вашему запросу нет подходящих объемов двигателя',
            noMatchingModelYears: 'Извините, по вашему запросу нет подходящих годов выпуска'
        },

        testDrive: {
            title: 'Тест-драйв',
            titleInDative: 'тест-драйву',

            vehicleUnavailable: 'Модель недоступна',
            alternativeVehicles: 'Красным выделены автомобили, наиболее близкие к выбранному',
            availableVehicles: 'В этом дилерском центре есть следующие подходящие автомобили',
            marker: 'Есть выбранная модель',
            activeMarker: 'Выбранный дилерский центр',
            bookingDateNotice: 'Запись производится только на 14 ближайших дней, начиная с текущей даты',
            bookingAlternativeTime: 'Если предпочтительное для Вас время не доступно, пожалуйста, свяжитесь с <span class="underscore">дилерским центром</span>',
            durationNotice: 'Продолжительность тест-драйва может варьироваться, но, пожалуйста, запланируйте по крайней мере час Вашего времени, чтобы получить максимум от Вашего тест-драйва.',
            vehicleChoice: 'Выберите автомобиль для тест-драйва',
            findDealers: 'Найдите дилерский центр',
            confirmation: 'Подтвердите Вашу запись на тест-драйв',
            moreAboutModel: 'Узнать больше о {name}',
            modelBrochure: '{name} в наличии',
            configureModel: 'Конфигурировать {name}',
            notAvailableDates: 'К сожалению, в ближайшие 2 недели нет доступного времени для проведения тест-драйва. Для уточнения деталей обратитесь в выбранный дилерский центр',
            confirmed: '{clientName}, дата и время Вашей записи на тест-драйв: <b>{time}</b>',
            confirmationInfo1: 'Письмо с деталями Вашего бронирования будет отправлено на <b>{email}</b>. Пожалуйста, прочитайте это письмо, чтобы убедиться в том, что Вы соответствуете всем требованиям. Могут применяться возрастные ограничения.',
            confirmationInfo2: 'Если у Вас есть какие-либо пожелания к тест-драйву, пожалуйста, сообщите когда мы свяжемся с Вами',
            confirmationInfo3: 'Если Вы хотите отменить или внести изменения в Ваше бронирование, пожалуйста, свяжитесь с дилерским центром по телефону: <b>{dealerName} {dealerPhone}</b>.',
            confirmationInfo4: '<b>Пожалуйста, не забудьте взять с собой водительское удостоверение.</b>',
            noMatchingVehicles: 'Извините, по вашему запросу нет подходящих автомобилей'
        }
    },
    en: {
        common: {
            submit: 'Continue',
            address: 'Address',
            telephone: 'Telephone',
            email: 'Email',
            fax: 'Fax',
            firstName: 'First Name',
            middleName: 'Middle Name',
            lastName: 'Last Name',
            viewOnMap: 'View on map',
            month: 'Please select a month',
            day: 'Please select a day',
            time: 'Please select an appointment time',
            confirmationTitle: 'Submit your booking',
            codeSMS: 'Enter SMS code here',
            cancelBooking: 'Cancel my booking',
            submitBooking: 'Submit my booking',
            userLocationTitle: 'Please enter your location to locate the closest retailers',
            userLocationDescription: 'Select your city',
            changeLocation: 'Change my location',
            footerMessage: 'The fuel consumption figures provided are as a result of official manufacturer`s tests in accordance with EU legislation.  \nA vehicle`s actual fuel consumption may differ from that achieved in such tests and these figures are for comparative purposes only.',
            phoneNotice: 'We will send a 6-digit SMS code to this number to confirm your booking',
            accept: 'I accept the',
            termsAndConditions: 'terms and conditions',
            confirmation: 'Confirmation your booking',
            confirmationNotice: 'You are about to receive a SMS containing a 6-digit code. ',
            confirmationInstruction: 'To complete your booking, enter the code below.',
            confirmationCode: 'We send the 6-digit code to',
            resendCode: 'Resend code',
            codeResended: 'We resend the code',
            bookingNumber: 'You booking number is',
            lookForward: 'We look forward to seeing you soon. Enjoy your drive!',
            directionsToRetailer: 'Directions to retailer',
            model: 'Model',
            yourDetails: 'Your Details',
            fieldsMandatory: 'All marked fields are mandatory',
            serverConnectionError: 'Failed to get a response from the server. Please try again later.',
            sessionExpired: 'Your session is expired',
            startOver: 'Start over',
            noCities: 'Sorry, accessible cities on your request is not found',
            limitExceededTitle: 'Limit for orders is exceeded',
            limitExceededMessage: 'Unfortunately, you have exceeded the limit for creating orders. To solve the problem, please contact the dealer center.',
            please: 'Please',

            //title active steps
            dealersCount: 'There are {dealersLength} {wordEn} close to you',
            completeForm: 'Please complete the form with your details',
            dayAndTime: 'Please select a day and appointment time',
        },

        stepNames: {
            vehicle: 'Vehicle',
            retailer: 'Retailer',
            dateAndTime: 'Date and time',
            contacts: 'Your details',
            name: 'Name',
            confirmation: 'Confirmation',
            edit: 'Edit',

            carAndDealer: 'Vehicle & Retailer',
            services: 'Select services',
        },

        validations: {
            required: 'Field {name} can`t be empty',
            alphaNum: 'Field {name} accepts only alphanumerics',
            isName: 'Field {name} accepts only symbols of alphabet, spaces and dashes',
            isVin: 'Field {name} accepts arabic numbers and symbols of latin alphabet, except letters I, O, Q',
            numeric: 'Field {name} accepts only numbers',
            email: 'Field {name} must correspond to a valid email address',
            isPhone: 'Field {name} must correspond to a valid phone number',
            phoneCode: 'Field Telephone must start with the code of one of the following countries: <br> Russia(+7), Belarus(+375), Kazakhstan(+7), Armenia(+374),  Ukraine(+380), Moldova(+373), Kyrgyzstan(+996), Tajikistan(+992), Uzbekistan(+998), Azerbaijan(+994)',
            maxLength: 'Field {name} can`t contains more {value} symbols',
            minLength: 'Field {name} can`t contains less {value} symbols',
            requiredAllFields: 'Please complete all fields',
            lengthEqual: 'Field {name} must contain {value} symbols',
            city: 'Please choose your city',
            services: 'Select at least one service',
            codeInvalid: '<b>Invalid confirmation code.</b> <br> Please enter the code you just received. ',
            time: 'Please, choose date and time',
            mobility: 'choose case of mobility',
            terms: 'To continue, please confirm your agreement with the terms and conditions of the service',
            zeroValue: 'The value of {name} field can not be zero',
            tooManyIncorrectCodes: 'Unfortunately, you have exceeded the limit of attempts to send a confirmation code. To solve the problem, please contact the Dealer Centre'
        },

        maintenance: {
            title: 'Service maintenance',
            titleInDative: 'service maintenance',
            //title active steps
            activeServices: 'Let use know which services your car needs',
            confirmation: 'Confirm your requirements',

            lookUpCar: 'Look up your car',
            addCar: 'Add your car',
            invalidVIN: 'This VIN code is invalid. Try entry vehicle info manually.',
            mileage: 'Mileage',
            modelYear: 'Model Year',
            engineSize: 'Engine Size',
            fuel: 'Fuel',
            airType: 'Air type',
            selectDealer: 'Choose a dealer center',
            selectDateTime: 'Choose date and time',
            selectMobility: 'Choose mobility case',
            deliveryChoice: 'Сhoose delivery and collection options',
            adviserChoice: 'Choose an adviser',
            dateTimeChoice: 'Choose your ideal date and time',
            dateTimeCall: 'Please call your retailer if you wish to clarify any times or dates on',
            chooseOne: 'Choose one',
            anyAdviser: 'Any Adviser',
            free: 'Free',
            yourDiscount: 'Your discount',
            totalPrice: 'Total price',
            additionalRequirements: 'Add your additional requirements',
            requiredPackages: 'Required packages',
            requirePackages: 'Required packages',
            scheduledMaintenancePackages: 'Routine maintenance',
            recommendPackages: 'Recommend packages',
            recommendedMaintenancePackages: 'Recommend packages',
            promoPackages: 'Promotional offers',
            carePackages: 'Car care',
            diagnosticsPackages: 'Diagnostics',
            accessoriesPackages: 'Accessories for your car',
            specialOffersPackages: 'Special offers',
            specialOffers: 'Special offers',
            reviewCampaigns: 'Review campaigns',
            city: 'City',
            confirmed: 'Thank you for entering your details. Your service is confirmed for:: <b>{time}</b>',
            confirmationInfo1: 'To clarify any questions about service, modification or cancellation of the service entry, please contact the selected dealer center: <b>{dealerName} {dealerPhone}</b>.',
            confirmationInfo21: 'An email with all the details will be sent to <b>{email}</b>.',
            confirmationInfo22: 'The total cost of the Services you\'ve selected will be <b>{totalCost}</b>',
            confirmationInfo23: 'To clarify any questions about service, modification or cancellation of the service entry, please contact the selected dealer center: <b>{dealerName} {dealerPhone}</b>.',
            noMatchingModels: 'Sorry, no matching models',
            noMatchingAirTypes: 'Sorry, no matching air types',
            noMatchingFuelTypes: 'Sorry, no matching fuel types',
            noMatchingEngineSizes: 'Sorry, no matching engine sizes',
            noMatchingModelYears: 'Sorry, no matching model years'
        },

        testDrive: {
            title: 'Test drive',
            titleInDative: 'test drive',

            vehicleUnavailable: 'Vehicle not available',
            alternativeVehicles: 'Red items show closest alternative to chosen vehicle',
            availableVehicles: 'This retailer has the following matching vehicles',
            marker: 'Exact vehicles matching',
            activeMarker: 'Selected retailer',
            bookingDateNotice: 'Booking are only accepted up to 14 days ahead of the current date',
            bookingAlternativeTime: 'If you wish to book an alternative time on this date, please contact your <span class="underscore">selected retailer</span>',
            durationNotice: 'Test drive duration will vary but please allow 1 hour to get the most from your test drive.',
            vehicleChoice: 'Select a vehicle to test drive',
            findDealers: 'Find a retailer',
            confirmation: 'Please confirm your test drive booking',
            moreAboutModel: 'More about the {name}',
            modelBrochure: '{name} in stock',
            configureModel: 'Configure the {name}',
            notAvailableDates: 'Unfortunately, in the next 2 weeks there is no available time for a test drive. For details, contact the selected dealer center',
            confirmed: '{clientName}, your test drive is confirmed for <b>{time}</b>',
            confirmationInfo1: 'An email with all the details will be sent to <b>{email}</b>. Please read this letter to make sure that you meet all the requirements. Age restrictions may apply.',
            confirmationInfo2: 'If there are any specific options you\'re looking to see as part of the test drive please let us know when we call you.',
            confirmationInfo3: 'If you need to reschedule or amend you booking you will need to do so by calling your chosen retailer by phone: <b>{dealerPhone}</b>.',
            confirmationInfo4: '<b>Please don\'t forget to bring your driving licecne on the day.</b>',
            noMatchingVehicles: 'Sorry, no matching vehicles'
        }
    }
};


export const i18n = new VueI18n({
    locale: 'ru',
    messages
});



// WEBPACK FOOTER //
// ./src/localizations/locales.js